import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { UserGroupAcl } from '@rocksoft/security-sdk';

export type UserGroupAclState = EntityState<UserGroupAcl>;

export function selectAclIdFromResourceId(userGroupAcl: UserGroupAcl) {
  return userGroupAcl.resourceId;
}

export const adapter: EntityAdapter<UserGroupAcl> = createEntityAdapter<UserGroupAcl>({
  selectId: selectAclIdFromResourceId,
});

export const initialState: UserGroupAclState = adapter.getInitialState();
